import { render } from "./CategoryBox.vue?vue&type=template&id=717ffcc5&scoped=true"
import script from "./CategoryBox.vue?vue&type=script&lang=js"
export * from "./CategoryBox.vue?vue&type=script&lang=js"

import "./CategoryBox.vue?vue&type=style&index=0&id=717ffcc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717ffcc5"]])

export default __exports__